import { Record } from 'immutable';

export const DRAWERS = {
  PAGE_OPTIONS: 'pageOptions',
  PAGE_MANAGER: 'pageManager',
};

const defaultValues = {
  [DRAWERS.PAGE_OPTIONS]: false,
  [DRAWERS.PAGE_MANAGER]: false,
};

export default class Drawer extends Record(defaultValues, Drawer) {
  constructor(values) {
    super({
      ...values,
    });
  }

  isOpen(drawerName) {
    return this.get(`${ drawerName }`);
  }

  toggleDrawer(drawerName) {
    if (this.isOpen(drawerName)) {
      return this.set(`${ drawerName }`, false);
    }
    return this.set(`${ drawerName }`, true);
  }
}
